import React, {Component} from 'react';
import './HeaderSectionComponent.less';

class HeaderSectionComponent extends Component {
    render() {
        return (
            <div className="HeaderSection">
                <h2 className="card__content text-300 text-white">{this.props.header}</h2>
            </div>
        );
    }
}

export default HeaderSectionComponent;
